<template>
    <div id="app">
        
        <!--<img src="./assets/wou_logo.png" v-if="isLogin">-->

        <!--<div id="nav" v-if="isLogin">
            <div class='nav-main-title' >
                <b>Event Management</b>
            </div>
            <div class='nav-list'>
                <div class="nav-el">
                    <router-link to="/">Home</router-link> 
                </div>
                <div class="nav-el">
                    <router-link to="/allEvents">All Events</router-link>
                </div> 
                <div class="nav-el">
                    <router-link to="/newEvent">Add Event</router-link> 
                </div>
                <div class="nav-el">
                    <router-link to="/Logout">Logout</router-link> 
                </div>
            </div>
               
        </div>-->

        <transition name="fade" mode="out-in">
            <router-view />
        </transition>
    </div>
</template>


<script>
import Vue from 'vue';
import router from '@/router/index'; 
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

export default Vue.extend({
    computed: {
        isLogin: {
            get() {
                return this.$store.state.user_login.isAuthorize;
            },
        },
    },
    beforeCreate(){
        document.title = "EMS";
        if(!this.$store.state.user_login.isAuthorize){
            router.push({ name: 'Login'});
        }
    }
})
</script>


<style lang="scss">
body{
    padding: 0;
    margin: 0;
}

#app {
    width: 100vw;
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background-color: #ffffff;
    min-height: 100vh;
}

#nav {
    display: flex;
    text-align: Left;
    background-color: #071D49;
    color: #ffffff;
    /*
    a {
        font-weight: bold;
        color: #ffffff;

        &.router-link-exact-active {
        color: #42b983;
        }
    }
    */
}

img{
    width: 150px;
    vertical-align: middle;
    padding: 10px;
}

.nav-main-title{
    padding: 15px;
    background-color: #84BD00;;
}

.nav-list{
    display:flex;
}

.nav-el{
    padding: 15px;
    
    a{
        font-weight: bold;
        color: #ffffff;
    }
}

.fade-enter-active, .fade-leave-active {
        transition: opacity .3s;
    }

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}
</style>
